var _g, _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 406 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M2759 1635h535v460h-535z",
    transform: "matrix(.75794 0 0 .2087 -2091.164 -341.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2850.89 1409.94v-87.28h10.91v78.19h69.1v9.09h-80.01Z",
    style: {
      fill: "url(#a)",
      fillRule: "nonzero"
    },
    transform: "matrix(.44925 0 0 .44925 -1159.711 -565.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3030.47 1389.94h-68.28l-11.39 20h-12.63l49.8-87.28h15.66l49.63 87.28h-11.45l-11.34-20Zm-5.16-9.09-28.92-50.97-29.02 50.97h57.94Z",
    style: {
      fill: "url(#b)",
      fillRule: "nonzero"
    },
    transform: "matrix(.44925 0 0 .44925 -1159.711 -565.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3080 1329.94v80h-10.91v-87.28h17.55l50.84 76.38 50.9-76.38h17.99v87.28h-10.91v-78.81l-51.82 78.81h-11.02l-52.62-80Z",
    style: {
      fill: "url(#c)",
      fillRule: "nonzero"
    },
    transform: "matrix(.44925 0 0 .44925 -1159.711 -565.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3330.07 1322.66v43.64c0 5.15-.06 9.85-.2 14.09-.13 4.25-.56 8.05-1.3 11.43-.74 3.37-1.91 6.3-3.5 8.8-1.59 2.5-3.86 4.58-6.82 6.23-2.95 1.64-6.71 2.87-11.28 3.69-4.56.81-10.18 1.22-16.84 1.22h-25.57c-6.67 0-12.29-.41-16.85-1.22-4.57-.82-8.32-2.05-11.28-3.69-2.96-1.65-5.24-3.73-6.85-6.23-1.61-2.5-2.78-5.43-3.52-8.8-.74-3.38-1.17-7.18-1.28-11.43-.11-4.24-.17-8.94-.17-14.09v-43.64h10.91v43.64c0 5.46.05 10.14.14 14.07.1 3.92.41 7.22.94 9.91.53 2.69 1.37 4.85 2.53 6.48 1.15 1.63 2.81 2.88 4.97 3.75 2.16.87 4.9 1.45 8.21 1.73 3.32.29 7.4.43 12.25.43h25.57c4.81 0 8.88-.14 12.21-.43 3.34-.28 6.07-.86 8.22-1.73 2.14-.87 3.79-2.12 4.97-3.75 1.17-1.63 2.03-3.79 2.58-6.48.55-2.69.86-5.99.94-9.91.07-3.93.11-8.61.11-14.07l-.05-43.64h10.96Z",
    style: {
      fill: "url(#d)",
      fillRule: "nonzero"
    },
    transform: "matrix(.44925 0 0 .44925 -1159.711 -565.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3403.26 1360.85c5.99 0 11.12.25 15.4.74 4.28.49 7.89 1.23 10.82 2.2 2.94.97 5.28 2.17 7.02 3.62 1.74 1.45 3.09 3.09 4.04 4.94.94 1.84 1.56 3.91 1.84 6.19.29 2.28.43 4.76.43 7.42 0 2.64-.24 5.12-.71 7.44-.48 2.32-1.32 4.44-2.53 6.37-1.21 1.92-2.86 3.63-4.94 5.14-2.09 1.51-4.74 2.8-7.96 3.85-3.22 1.06-7.09 1.86-11.62 2.41-4.53.54-9.82.82-15.88.82h-14.55c-5.45 0-10.23-.21-14.32-.63-4.09-.41-7.61-1.05-10.57-1.9-2.95-.85-5.39-1.93-7.33-3.24-1.93-1.31-3.47-2.84-4.63-4.6-1.15-1.76-1.96-3.77-2.41-6.03-.46-2.25-.68-4.74-.68-7.47h10.91c0 3.47.49 6.18 1.47 8.14.99 1.96 2.62 3.43 4.89 4.41 2.27.98 5.26 1.6 8.95 1.85 3.69.25 8.27.38 13.72.38h14.55c6.36 0 11.65-.31 15.85-.92 4.21-.61 7.56-1.58 10.06-2.92 2.5-1.33 4.26-3.08 5.28-5.23 1.03-2.16 1.54-4.78 1.54-7.87s-.35-5.66-1.05-7.72c-.7-2.07-2.09-3.7-4.15-4.92-2.06-1.23-4.97-2.09-8.72-2.61-3.75-.51-8.66-.77-14.72-.77h-15c-6.67 0-12.38-.25-17.13-.74-4.76-.49-8.74-1.2-11.96-2.13-3.22-.93-5.8-2.08-7.73-3.47-1.93-1.38-3.4-2.96-4.41-4.74-1-1.78-1.65-3.76-1.96-5.94-.3-2.18-.45-4.54-.45-7.07 0-2.66.24-5.12.71-7.39.47-2.27 1.35-4.33 2.64-6.17 1.29-1.83 3.05-3.47 5.29-4.91 2.23-1.44 5.1-2.64 8.61-3.61 3.5-.96 7.71-1.69 12.64-2.19 4.92-.49 10.72-.74 17.39-.74h10.91c5.45 0 10.22.2 14.31.6 4.1.4 7.62 1.02 10.57 1.88 2.96.85 5.41 1.91 7.36 3.18 1.95 1.27 3.51 2.78 4.66 4.54 1.16 1.77 1.96 3.76 2.42 6 .45 2.23.68 4.72.68 7.44h-10.91c0-3.41-.49-6.08-1.48-8.01-.98-1.93-2.61-3.38-4.89-4.35-2.27-.96-5.26-1.57-8.97-1.81-3.72-.25-8.3-.37-13.75-.37h-10.91c-7.28 0-13.26.25-17.96.76-4.7.51-8.41 1.38-11.14 2.59-2.72 1.21-4.62 2.84-5.68 4.88-1.06 2.05-1.59 4.61-1.59 7.68 0 1.89.13 3.58.4 5.05.26 1.48.8 2.78 1.62 3.9.81 1.11 1.96 2.05 3.43 2.81 1.48.76 3.43 1.38 5.86 1.87 2.42.5 5.39.85 8.89 1.06 3.5.2 7.68.31 12.53.31h15Z",
    style: {
      fill: "url(#e)",
      fillRule: "nonzero"
    },
    transform: "matrix(.44925 0 0 .44925 -1159.711 -565.86)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.39212 0 0 .39212 -1456.38 -195.188)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3880.14 556.644c-5.45-6.406-14.02-12.009-27.32-12.009-14.02 0-23.43 5.354-29.54 12.009-5.45-6.406-14.02-12.009-27.32-12.009-31.03 0-39.48 26.232-39.48 34.745 0 8.512-.53 80.545-.53 80.545s-2.12 12.635-14.74 12.635c-12.61 0-14.21.527-14.21.527s8.56 22.637 34.74 22.637c12.5 0 22.3-5.215 29.13-11.896 5.37 5.845 14.19 11.896 27.73 11.896 12.49 0 22.29-5.215 29.12-11.896 5.37 5.845 14.2 11.896 27.74 11.896 26.18 0 40.53-22.907 40.53-34.219 0-11.312-.52-73.176-.52-73.176s2.14-13.161 14.74-13.161H3946s-5.29-30.533-36.32-30.533c-14.03 0-23.44 5.354-29.54 12.009Zm-9.51 18.746c-10.19 1.725-12.02 12.939-12.02 12.939s.53 61.864.53 73.176c0 3.054-1.05 6.954-3.09 11.021 11.62-.722 13.62-12.601 13.62-12.601s.52-72.033.52-80.545c0-1.076.14-2.435.44-3.99Zm-56.86 0c-10.19 1.725-12.01 12.939-12.01 12.939s.52 61.864.52 73.176c0 3.054-1.04 6.954-3.09 11.021 11.62-.722 13.62-12.601 13.62-12.601s.53-72.033.53-80.545c0-1.076.13-2.435.43-3.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 5.07,
    y: 18.611,
    width: 85.875,
    height: 59.245,
    transform: "matrix(2.54651 0 0 2.51815 3714.09 497.769)"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(598.893) rotate(-8.754 17.782 -29.918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#484848",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(598.893) rotate(-8.754 17.782 -29.918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#484848",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(598.893) rotate(-8.754 17.782 -29.918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#484848",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(598.893) rotate(-8.754 17.782 -29.918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#484848",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(598.893) rotate(-8.754 17.782 -29.918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#484848",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "g",
    width: 86,
    height: 60,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCAA8AFYDAREAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAwAGAgH/xAAYEAEBAQEBAAAAAAAAAAAAAAAAAQIRIf/EABUBAQEAAAAAAAAAAAAAAAAAAAAH/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A6xUNVo2KBsUD4oGxQNigfFAkB6CBAyGbwDYoHxQNigbFA+KBsUDYoOwQIGPAmKBsUDYoGxQPigbFA2KBpewHoIGPB7LygXFA2KB8UDYoGxQPigbFAgIGPBA6xQPigbFA2KB8UDYoGxQNm9B0DHggUAuKBsUD4oGxQNigfFA2KBYDHggQOs0DYoGxQNigfFA2KBsUDZvgMkCBAgJigfFA2KBsUD4oGxQNm+A//9k="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logo-name.a030b21cc44fd20bf26e53b3f2e3b1d8.svg";
export { ForwardRef as ReactComponent };